(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxRecalculateActions', {
		require: {
			mxDialogContainerCtrl: '?^mxDialogContainer',
		},
		bindings: {
			sourceState: '<',
			condition: '<',
		},
		controller: MxRecalculateActionsCtrl,
		controllerAs: 'vm',
	});

	MxRecalculateActionsCtrl.$inject = ['mx.shell.SidePanelActionsService'];

	function MxRecalculateActionsCtrl(sidePanelActionsService) {
		var vm = this;
		vm.$onChanges = function (changes) {
			var conditionChanged = changes.condition && changes.condition.currentValue !== changes.condition.previousValue && changes.condition.currentValue;
			var sourceStateChanged =
				changes.sourceState &&
				changes.sourceState.currentValue !== changes.sourceState.previousValue &&
				changes.sourceState.currentValue === mx.SolutionBuilderAgent.SourceLoadingStatus.LOADED;
			var isSourceSet = changes.sourceState?.currentValue !== mx.SolutionBuilderAgent.SourceLoadingStatus.NOT_SET;

			if (!isSourceSet || conditionChanged || sourceStateChanged) {
				sidePanelActionsService.calculateViewActions(vm.mxDialogContainerCtrl.view);
			}
		};

		return vm;
	}
})();
